import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import usePageMeta from "../hooks/usePageMeta";

export default function EmailPreferences() {
  usePageMeta("Email Preferences | Tiff. Wellness Co.", "Manage your tiff. wellness co. email preferences.", { robots: "noindex,nofollow" });
  const { user } = useAuth();
  const navigate = useNavigate();
  const [prefs, setPrefs] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user === false) navigate("/auth?next=/email-preferences");
    if (user && user !== false) api.get("/account/email-preferences").then((r) => setPrefs(r.data));
  }, [user]); // eslint-disable-line

  const save = async (value) => {
    setBusy(true);
    try {
      const { data } = await api.put("/account/email-preferences", { marketing_opt_in: value });
      setPrefs({ ...prefs, marketing_opt_in: data.marketing_opt_in, unsubscribed: !data.marketing_opt_in && prefs.unsubscribed });
      toast.success(value ? "You're opted in to marketing email." : "Opted out — queued marketing emails canceled. Paid subscriptions are unaffected.");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  if (!prefs) return <div className="py-20 text-center text-sm">Loading…</div>;
  return (
    <div className="max-w-xl mx-auto px-4 py-16">
      <h1 className="text-4xl mb-6">Your Email Preferences</h1>
      <div className="card-paper p-6">
        <h2 className="text-lg font-medium mb-3">Marketing Preferences</h2>
        <label className="flex items-start gap-3 text-sm">
          <input data-testid="email-pref-marketing-toggle" type="checkbox" className="mt-0.5 h-5 w-5" disabled={busy}
            checked={prefs.marketing_opt_in} onChange={(e) => save(e.target.checked)} />
          <span>Send me marketing email about new pickups, juices and plans. Opting out never cancels a paid juice subscription — transactional order emails still arrive.</span>
        </label>
      </div>
    </div>
  );
}
